module.exports = __webpack_public_path__ + "img/impact-bottom.84e17298.png";